export default {
  marquee: [{ required: true, message: '请选择是否为跑马灯公告' }],
  title: [{ required: true, message: '请输入标题' }],
}
